<ng-container *ngIf="!showLoader; else loader">
  @if (loading) {
  <app-loader variant="almostready"></app-loader>
  } @else if (error) {
  <div class="error-container">
    <div class="error-content">
      <h1>{{ 'fullResults.scanNotFound' | translate }}</h1>
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="navigateToDashboard()">
        {{ 'fullResults.returnToDashboard' | translate }}
      </button>
    </div>
  </div>
  } @else { @if (result) {
<!--  <app-conversion-tracking></app-conversion-tracking>-->
  @if (!showSymtomsPage && !showDoctorSection) {
  <div class="min-h-screen screen-wrapper">
    <div class="inner-container">
      <div class="full-result-body">
        <h1 class="full-result-title">
          {{ 'fullResults.greeting' | translate }}
          <span class="bright-pink text-capital">
            {{ sessionService.session.user.fname }}
            {{ sessionService.session.user.lname }} 👋</span>
        </h1>
        <h2 class="full-result-title">
          <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.reportReady' | translate }}
        </h2>

        <p>
          {{ 'fullResults.aiAnalyzedIntro' | translate }}
        </p>

        <div class="charset">
          <div class="charset-score-title">
            <h4>
              <span class="bright-pink">{{ 'fullResults.your' | translate }}</span>
              {{
              brandName === "Peritale"
              ? ('fullResults.perimenopauseIndicationScore' | translate)
              : ('fullResults.markableAnalysisScore' | translate)
              }}
            </h4>
          </div>

          <div class="score-circle">
            <svg viewBox="0 0 120 120" class="circular-progress">
              <circle cx="60" cy="60" r="50" fill="none" stroke="#e0e0e0" stroke-width="8" class="progress-bg" />
              <circle cx="60" cy="60" r="50" fill="none" stroke="var(--brand-color)" stroke-width="8"
                stroke-linecap="round" class="progress-bar" [style.stroke-dasharray]="314.16" [style.stroke-dashoffset]="
                  314.16 - (314.16 * result.score.total_score_relative) / 100
                " />
            </svg>
            <div class="percent">
              <span class="percentNum">&nbsp;{{
                result.score.total_score_relative
                }}</span>
              <span class="percentB">%</span>
            </div>
          </div>

          <p class="text" *ngIf="brandName === 'Peritale'">
            {{ 'fullResults.indicationLevelPrefix' | translate }}
            <span class="bright-pink"><b>{{ getLevel(result.score.total_score_relative) }} {{ 'fullResults.indicationLevelLabel' | translate }}</b></span>
            {{ 'fullResults.indicationLevelSuffix' | translate }}
          </p>
          <p class="text" *ngIf="brandName !== 'Peritale'">
            {{ 'fullResults.markableLevelPrefix' | translate }}
            <span class="bright-pink"><b>{{ getLevel(result.score.total_score_relative) }} {{ 'fullResults.levelLabel' | translate }}</b></span>
            {{ 'fullResults.markableLevelSuffix' | translate }}
          </p>
        </div>

        <!-- <p>It is a long established <span class="bright-pink">fact that a reader will be distracted</span> by the readable
                      content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                      normal distribution of letters</p> -->
        <h4>{{ 'fullResults.analyzedSelfie' | translate }}</h4>
        @if (base64Front && base64Front != "") {
        <app-skin-filter-viewer [photoUrl]="base64Front" [filterData]="skinAnalysisData" [maskImages]="maskImages">
        </app-skin-filter-viewer>
        } @if (hasSkinAnalysisData()) {
        <h4>{{ 'fullResults.skinScoreKeyMatrix' | translate }}</h4>
        <div>
          <app-skin-radar-chart [skinAnalysisData]="skinAnalysisData"></app-skin-radar-chart>
        </div>
        }

        <h4 *ngIf="brandName === 'Peritale'">
          {{ 'fullResults.howDidWeReachPerimenopause' | translate }}
        </h4>
        <h4 *ngIf="brandName !== 'Peritale'">
          {{ 'fullResults.howDidWeReachAnalysis' | translate }}
        </h4>
        <p>
          {{ 'fullResults.brandUsesAi' | translate: { brand: brandName } }}
        </p>
        <h4>{{ 'fullResults.detectedBiomarkers' | translate }}</h4>
        <div class="charset-list-wrapper">
          <app-biomarker-card [data]="result" [type]="'eye_analysis'"></app-biomarker-card>
        </div>
        <div class="charset-list-wrapper">
          <app-biomarker-card [data]="result" [type]="'skin_analysis'"></app-biomarker-card>
        </div>
        <div *ngIf="brandName === 'Peritale'" class="m-t-20">
          <h4>{{ 'fullResults.whatsNext' | translate }}</h4>
          <p>
            {{ 'fullResults.whatsNextBody' | translate }}
          </p>
        </div>
        <div *ngIf="brandName === 'Peritale'" class="charset-list-wrapper cursor-pointer" (click)="moveToDoctor()">
          <div class="card card-section">
            <div class="image-container">
              <img src="../../assets/images/doctor.png" [alt]="'fullResults.questionMark' | translate" />
            </div>
            <div class="text-container">
              <h3>
                {{ 'fullResults.howToTalkWithPrefix' | translate }} <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.howToTalkWithSuffix' | translate }}
              </h3>
            </div>
          </div>
        </div>
        <div class="charset-list-wrapper cursor-pointer" (click)="moveToSymptoms()"
          *ngIf="symptomsInfo?.length > 0 && brandName === 'Peritale'">
          <div class="card card-section">
            <div class="image-container">
              <img src="../../assets/images/understanding-your-symtoms.png" [alt]="'fullResults.questionMark' | translate" />
            </div>
            <div class="text-container">
              <h3>
                {{ 'fullResults.understandingPrefix' | translate }} <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.understandingSuffix' | translate }}
              </h3>
            </div>
          </div>
        </div>
        <!-- <app-card-images></app-card-images> -->
      </div>
    </div>
  </div>
  } @else if (showDoctorSection) {
  <div class="symptoms-container" #cardContainer>
    <div class="back-button cursor-pointer" (click)="back()">
      <mat-icon class="rtl-icon">arrow_back</mat-icon>
      <span>{{ 'fullResults.back' | translate }}</span>
    </div>
    <div class="card card-section">
      <div class="image-container">
        <img src="../../assets/images/doctor.png" [alt]="'fullResults.questionMark' | translate" />
      </div>
      <div class="text-container">
        <h3>{{ 'fullResults.howToTalkWithPrefix' | translate }} <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.howToTalkWithSuffix' | translate }}</h3>
      </div>
    </div>

    <div class="talk-doctor-section-content">
      <div>
        <p>
          {{ 'fullResults.talkingWithGp' | translate }}
        </p>
      </div>
      <div class="talk-doctor-content-links">
        <div class="image-card cursor-pointer">
          <a target="_blank" href="https://www.peritale.online/track-your-symptoms">
            <p>{{ 'fullResults.trackPrefix' | translate }} <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.trackSuffix' | translate }}</p>
            <mat-icon class="bright-pink">chevron_right</mat-icon>
          </a>
        </div>
        <div class="image-card cursor-pointer">
          <a target="_blank" href="https://www.peritale.online/speak-up-your-perimenopause-visit-guide">
            <p>
              {{ 'fullResults.speakUpPrefix' | translate }} <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.speakUpSuffix' | translate }}
            </p>
            <mat-icon class="bright-pink rtl-icon">chevron_right</mat-icon>
          </a>
        </div>
        <!--            <div class="image-card cursor-pointer">-->
        <!--              <a target="_blank" href="https://www.peritale.online/explore-symptoms-treatments-and-more">-->
        <!--                <p>Explore Symptoms, Treatments, and More</p>-->
        <!--                <mat-icon class="bright-pink">chevron_right</mat-icon>-->
        <!--              </a>-->
        <!--            </div>-->
      </div>
    </div>
  </div>
  } @else {
  <div class="symptoms-container" #cardContainer>
    <div class="back-button cursor-pointer" (click)="back()">
      <mat-icon class="rtl-icon">arrow_back</mat-icon>
      <span>{{ 'fullResults.back' | translate }}</span>
    </div>
    <div class="card card-section">
      <div class="image-container">
        <img src="../../assets/images/understanding-your-symtoms.png" [alt]="'fullResults.questionMark' | translate" />
      </div>
      <div class="text-container">
        <h3>{{ 'fullResults.understandingPrefix' | translate }} <span class="bright-pink">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.understandingSuffix' | translate }}</h3>
      </div>
    </div>
    @for (symptom of symptomsInfo; track symptom) {
    <div class="image-card cursor-pointer" (click)="showSymptomsInfo(symptom.slug)">
      <img src="{{ symptom.image }}" alt="{{ symptom.title }}" />
      <p>{{ symptom.title }}</p>
    </div>
    }
  </div>
  } } }
  <button class="time-to-feel-like-you-again" mat-raised-button color="primary">
    {{ 'fullResults.timeToFeelLikeYou' | translate }}
  </button>
</ng-container>

<ng-template #loader>
  <app-loader variant="almostready"></app-loader>
</ng-template>
